import { useEffect, useState } from 'react';
import { sendRequest } from '../../hooks/requests/useRequest';
import { validarSesion } from '../../hooks/tokens/useToken';
import { useForm } from '../../hooks/forms/useForm';
import { useSweetAlert } from '../../hooks/sweetAlerts/useSweetAlert';
import { useHistory } from 'react-router';


export const useUnitsConversions = (props) => {
    const { activeTab } = props;
    const history = useHistory();

    useEffect(() => {
        getUnitsConversions();
        getUnits();
    }, [history.location]);

    useEffect(() => {
        if (activeTab === 2) {
            getUnits();
        }
    }, [activeTab]);

    const [unitsConversions, setUnitsConversions] = useState([]);
    const [units, setUnits] = useState({});
    const [method, setMethod] = useState("");
    const [modal, setModal] = useState(false);
    const [unitConversionId, setUnitConversionId] = useState(0);
    const [loading, setLoading] = useState(false);
    const [createSweet] = useSweetAlert();

    //? DIALOG DELETE
    const [modalAlert, setModalAlert] = useState(false);
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);

    //? SEARCH AND EXCEL
    const [loadingExcel, setLoadingExcel] = useState(false);
    const [searchUnitConversion, setSearchUnitConversion] = useState("");
    const [unitConversionsData, setUnitConversionsData] = useState([]);


    const openDialog = (title, mode) => {
        // setModalTitle(title);
        setMethod(mode);
        setModal(true);
    };

    const closeDialog = () => {
        setModal(false);
    };

    const openDeleteAlert = () => {
        setShowDeleteAlert(true); 
        setModalAlert(true);  
    };

    const closeDeleteAlert = () => {
        setModalAlert(false);   
    };


    const [formValues, handleInputChange, reset, handleUpdateValues] = useForm({
        id_unit_from: 0,
        id_unit_to: 0,
        conversion_factor: 0
    });

    const { id_unit_from, id_unit_to, conversion_factor } = formValues;


    const getUnits = async () => {
        let requestOptions = {
            method: 'GET',
            redirect: 'follow'
        };

        const respuesta = await sendRequest(requestOptions, "Units");
        if (respuesta.code === 200) {
            setUnits(respuesta.data);
        } else {
            validarSesion(history, respuesta.code, getUnits);
        }
    }

    const getUnitsConversions = async () => {
        let requestOptions = {
            method: 'GET',
            redirect: 'follow'
        };

        const respuesta = await sendRequest(requestOptions, "UnitConversions");
        if (respuesta.code === 200) {
            setUnitsConversions(respuesta.data);
            setUnitConversionsData(respuesta.data);
        } else {
            validarSesion(history, respuesta.code, getUnitsConversions);
        }
    }

    const handleCreate = () => {
        handleUpdateValues({
            id_unit_from: "",
            id_unit_to: "",
            conversion_factor: ""
        });
        setUnitConversionId(0);
        setMethod("create");
        openDialog("Crear unidad de conversión", "create");
    }

    const saveCreate = async (e) => {
        e.preventDefault();
        if (formValues.id_unit_from <= 0) {
            alert("Debes de seleccionar una unidad de origen");
        } else if (formValues.id_unit_to <= 0) {
            alert("Debes de seleccionar una unidad de destino");
        } else if (formValues.conversion_factor <= 0) {
            alert("El factor de conversión debe de ser mayor a 1.");
        }
        else {
            setLoading(true);
            let raw = JSON.stringify(formValues);
            let requestOptions = {
                method: 'POST',
                body: raw,
                redirect: 'follow'
            };

            const respuesta = await sendRequest(requestOptions, "UnitConversions");

            if (respuesta.code === 200) {
                let unit_from = units.find(u => u.id_unit === parseInt(formValues.id_unit_from));
                let unit_to = units.find(u => u.id_unit === parseInt(formValues.id_unit_to));
                let newUnitsConversions = unitsConversions;

                newUnitsConversions.push({
                    id_unit_conversion: respuesta.data.id_unit_conversion,
                    id_unit_from: id_unit_from,
                    id_unit_to: id_unit_to,
                    name_unit_from: unit_from.unit,
                    name_unit_to: unit_to.unit,
                    abbreviation_unit_from: unit_from.abbreviation,
                    abbreviation_unit_to: unit_to.abbreviation,
                    conversion_factor: conversion_factor,
                })
                setUnitsConversions(newUnitsConversions);
                reset();
                setLoading(false);
                createSweet("create", "success");
                closeDialog();

            } else {
                ////console.log("Error al crear la unidad de conversion...");
                validarSesion(history, respuesta.code, saveCreate);
            }
        }
    }

    const handleUpdate = (id_unit_conversion) => {
        let unit_conversion = unitsConversions.find(uc => uc.id_unit_conversion === id_unit_conversion);
        handleUpdateValues({
            id_unit_from: unit_conversion.id_unit_from,
            id_unit_to: unit_conversion.id_unit_to,
            conversion_factor: unit_conversion.conversion_factor
        });
        setUnitConversionId(id_unit_conversion);
        setMethod("update");
        openDialog("Editar unidad de conversión", "update");
    }

    const saveUpdate = async (e) => {
        e.preventDefault();
        let body = {
            id_unit_conversion: unitConversionId,
            ...{ ...formValues }
        }
        setLoading(true);
        let raw = JSON.stringify(body);
        let requestOptions = {
            method: 'PUT',
            body: raw,
            redirect: 'follow'
        };

        const respuesta = await sendRequest(requestOptions, "UnitConversions");
        if (respuesta.code === 200) {
            let unit_from = units.find(u => u.id_unit === parseInt(id_unit_from));
            let unit_to = units.find(u => u.id_unit === parseInt(id_unit_to));
            let newUnitsConversions = unitsConversions.map(function (obj) {
                if (obj.id_unit_conversion === unitConversionId) {
                    obj.id_unit_from = id_unit_from;
                    obj.id_unit_to = id_unit_to;
                    obj.conversion_factor = conversion_factor;
                    obj.name_unit_from = unit_from.unit;
                    obj.abbreviation_unit_from = unit_from.abbreviation;
                    obj.abbreviation_unit_to = unit_to.abbreviation;
                    obj.name_unit_to = unit_to.unit;
                }
                return obj;
            });
            setUnitsConversions(newUnitsConversions);
            setLoading(false);
            createSweet("update", "success");
            closeDialog();
        } else {
            validarSesion(history, respuesta.code, saveUpdate);
            ////console.log("Ocurrio un error");
        }
    }

    const handleDelete = (id_unit_conversion) => {

        let unit_conversion = unitsConversions.find(uc => uc.id_unit_conversion === id_unit_conversion);
        handleUpdateValues({
            id_unit_from: unit_conversion.id_unit_from,
            id_unit_to: unit_conversion.id_unit_to,
            conversion_factor: unit_conversion.conversion_factor
        });
        setUnitConversionId(id_unit_conversion);
        setMethod("delete");
        openDeleteAlert();
    }

    const saveDelete = async (e) => {
        e.preventDefault();
        let requestOptions = {
            method: 'DELETE',
            redirect: 'follow'
        };
        setLoading(true);
        const respuesta = await sendRequest(requestOptions, `UnitConversions/${unitConversionId}`);
        if (respuesta.code === 200) {
            let newUnitsConversions = unitsConversions.filter(u => u.id_unit_conversion !== unitConversionId);
            setUnitsConversions(newUnitsConversions);
            setLoading(false);
            createSweet("delete", "success");
            closeDeleteAlert();
        } else {
            validarSesion(history, respuesta.code, saveDelete);
            ////console.log("Error");
        }
    }

    //#region Search
    const handleSearchUnitConversion = (value) => {

        setSearchUnitConversion(value);

        let busqueda = value.toUpperCase();

        let newUnitConversions = [];

        if (busqueda === "") {

            setUnitsConversions([...unitConversionsData]);

        } else {

            unitConversionsData.forEach(element => {

                let cadenaNameFrom = element.name_unit_from?.toUpperCase() || "";
                let cadenaNameTo = element.name_unit_to?.toUpperCase() || "";

                let cadenaAbbrFrom = element.abbreviation_unit_from?.toUpperCase() || "";
                let cadenaAbbrTo = element.abbreviation_unit_to?.toUpperCase() || "";

                let cadenaFactor = element.conversion_factor?.toString().toUpperCase() || "";

                if (
                    cadenaNameFrom.indexOf(busqueda) > -1 ||
                    cadenaNameTo.indexOf(busqueda) > -1 ||
                    cadenaAbbrFrom.indexOf(busqueda) > -1 ||
                    cadenaAbbrTo.indexOf(busqueda) > -1 ||
                    cadenaFactor.indexOf(busqueda) > -1
                ) {

                    element.visibleTable = true;

                    newUnitConversions.push(element);
                }
            });

            setUnitsConversions([...newUnitConversions]);
        }
    };
    const handleClearUnitConversion = () => {

        setSearchUnitConversion("");

        localStorage.removeItem("globalFilter");

        setUnitsConversions(unitConversionsData);
    };
    //#endregion

    //#region List excel
    const handleExcelUnitConversion = async () => {
        setLoadingExcel(true);
        try {
            const XLSX = await import("xlsx");
            const _report = unitsConversions.map((item, index) => ({
                "#": index + 1,
                "Unidad origen": item.name_unit_from ?? "---",
                "Unidad destino": item.name_unit_to ?? "---",
                "Abr origen": item.abbreviation_unit_from ?? "---",
                "Abr destino": item.abbreviation_unit_to ?? "---",
                "Factor de conversión": item.conversion_factor ?? "---"
            }));

            const worksheet = XLSX.utils.json_to_sheet(_report);

            const workbook = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet( workbook, worksheet, "UnidadesConversión" );

            const excelBuffer = XLSX.write(workbook, {
                bookType: "xlsx",
                type: "array"
            });

            const dataBlob = new Blob(
                [excelBuffer],
                {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                }
            );

            const url = window.URL.createObjectURL(dataBlob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "catalogo_unidades_conversion.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {

            console.error("Error al exportar Excel", error);
        }

        setLoadingExcel(false);
    };

    //#endregion

    return {
        unitsConversions, units, method,
        handleInputChange, id_unit_from, id_unit_to, conversion_factor,
        closeDialog, modal, loading,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        handleExcelUnitConversion, loadingExcel,
        handleSearchUnitConversion, searchUnitConversion, 
        handleClearUnitConversion, showDeleteAlert, 
        modalAlert, closeDeleteAlert
    };
}
